/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListNursingHomesQueryResponse,
  ListNursingHomesQueryParams,
} from '../types/ListNursingHomes'

function getListNursingHomesUrl() {
  const res = { method: 'GET', url: `/api/v1/nursing_home/` as const }
  return res
}

/**
 * @summary List nursing homes
 * {@link /api/v1/nursing_home/}
 */
export async function listNursingHomes(
  params?: ListNursingHomesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListNursingHomesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListNursingHomesUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
